'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" fillRule="evenodd" d="M7.71 22.133Q9.717 23 12 23t4.29-.867a11.1 11.1 0 0 0 3.492-2.35q1.485-1.486 2.351-3.493Q23 14.283 23 12t-.867-4.29a11.1 11.1 0 0 0-2.35-3.492 11.1 11.1 0 0 0-3.493-2.352A10.7 10.7 0 0 0 12 1q-2.283 0-4.29.866a11.1 11.1 0 0 0-3.493 2.352 11.1 11.1 0 0 0-2.35 3.492A10.7 10.7 0 0 0 1 12q0 2.283.867 4.29a11.1 11.1 0 0 0 2.35 3.492 11.1 11.1 0 0 0 3.493 2.351m10.532-3.89Q15.684 20.8 12 20.8a9 9 0 0 1-3.08-.515l1.81-4.072a4.4 4.4 0 0 1-1.006-.448l-1.812 4.077a8.8 8.8 0 0 1-2.155-1.6Q3.2 15.686 3.2 12q0-2.286.984-4.139L8.111 9.94A4.4 4.4 0 1 0 12 7.6v-4.4q3.684 0 6.241 2.558Q20.8 8.315 20.8 12t-2.558 6.243M15.3 11.999a3.3 3.3 0 1 1-6.6 0 3.3 3.3 0 0 1 6.6 0" clipRule="evenodd" /></svg>;
const IconShareOfVoice = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconShareOfVoice;